import { default as i18n } from 'i18next';

import en from './en.json';
import de from './de.json';

type I18nVoucherOverviewParams = {
    lng: string;
    translations?: {
        en?: Record<string, string>;
        de?: Record<string, string>;
    };
};

export const initI18nNextVoucherOverview = ({
    lng,
    translations,
}: I18nVoucherOverviewParams) => {
    const deOverrides = translations?.de || {};
    const enOverrides = translations?.en || {};

    const instance = i18n.createInstance();
    instance.init({
        resources: {
            en: { translation: { ...en, ...enOverrides } },
            de: { translation: { ...de, ...deOverrides } },
        },
        lng,
        fallbackLng: 'de',
        interpolation: {
            escapeValue: false,
        },
    });
    return instance;
};
